module.exports = __webpack_public_path__ + "static/media/24-7.2fc09613.mp3";